/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateRadiologyPointPollutantDto } from '../models';
import { RadiologyPointPollutant } from '../models';
import { UpdateRadiologyPointPollutantDto } from '../models';
import { getFromStorage } from '../../app/helpers';
/**
 * RadiologyPointPollutantsApi - axios parameter creator
 * @export
 */
export const RadiologyPointPollutantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRadiologyPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerCreate: async (body: CreateRadiologyPointPollutantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling radiologyPointPollutantsControllerCreate.');
            }
            const localVarPath = `/radiology-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/radiology-point-pollutants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerFindByPointId: async (pointId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pointId' is not null or undefined
            if (pointId === null || pointId === undefined) {
                throw new RequiredError('pointId','Required parameter pointId was null or undefined when calling radiologyPointPollutantsControllerFindByPointId.');
            }
            const localVarPath = `/radiology-point-pollutants/point/{pointId}`
                .replace(`{${"pointId"}}`, encodeURIComponent(String(pointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling radiologyPointPollutantsControllerFindOne.');
            }
            const localVarPath = `/radiology-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling radiologyPointPollutantsControllerRemove.');
            }
            const localVarPath = `/radiology-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateRadiologyPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radiologyPointPollutantsControllerUpdate: async (body: UpdateRadiologyPointPollutantDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling radiologyPointPollutantsControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling radiologyPointPollutantsControllerUpdate.');
            }
            const localVarPath = `/radiology-point-pollutants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");


            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers || {})["Content-Type"] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RadiologyPointPollutantsApi - functional programming interface
 * @export
 */
export const RadiologyPointPollutantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRadiologyPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerCreate(body: CreateRadiologyPointPollutantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RadiologyPointPollutant>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerCreate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<RadiologyPointPollutant>>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<RadiologyPointPollutant>>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerFindByPointId(pointId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RadiologyPointPollutant>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RadiologyPointPollutant>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerRemove(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateRadiologyPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerUpdate(body: UpdateRadiologyPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RadiologyPointPollutant>>> {
            const localVarAxiosArgs = await RadiologyPointPollutantsApiAxiosParamCreator(configuration).radiologyPointPollutantsControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RadiologyPointPollutantsApi - factory interface
 * @export
 */
export const RadiologyPointPollutantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {CreateRadiologyPointPollutantDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerCreate(body: CreateRadiologyPointPollutantDto, options?: AxiosRequestConfig): Promise<AxiosResponse<RadiologyPointPollutant>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<RadiologyPointPollutant>>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<RadiologyPointPollutant>>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RadiologyPointPollutant>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RadiologyPointPollutant>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateRadiologyPointPollutantDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radiologyPointPollutantsControllerUpdate(body: UpdateRadiologyPointPollutantDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RadiologyPointPollutant>> {
            return RadiologyPointPollutantsApiFp(configuration).radiologyPointPollutantsControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RadiologyPointPollutantsApi - object-oriented interface
 * @export
 * @class RadiologyPointPollutantsApi
 * @extends {BaseAPI}
 */
export class RadiologyPointPollutantsApi extends BaseAPI {
    /**
     * 
     * @param {CreateRadiologyPointPollutantDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerCreate(body: CreateRadiologyPointPollutantDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<RadiologyPointPollutant>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<RadiologyPointPollutant>>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} pointId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerFindByPointId(pointId: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<RadiologyPointPollutant>>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerFindByPointId(pointId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RadiologyPointPollutant>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerRemove(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RadiologyPointPollutant>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateRadiologyPointPollutantDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RadiologyPointPollutantsApi
     */
    public async radiologyPointPollutantsControllerUpdate(body: UpdateRadiologyPointPollutantDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RadiologyPointPollutant>> {
        return RadiologyPointPollutantsApiFp(this.configuration).radiologyPointPollutantsControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
